"use client"

import useSWR from "swr"

import { fetchRecommendedGames } from "@/client-api/casino/recommended"
import type { LobbySuggestion } from "@/domain/casino/listing/types"

type RecommendedGamesState = {
  games: LobbySuggestion[]
  isLoading: boolean
  isError: boolean
}

export function useRecommendedGames(): RecommendedGamesState {
  const { data, error, isLoading } = useSWR(
    ["casino/recommended-games"],
    () => fetchRecommendedGames(),
    { revalidateOnFocus: false }
  )

  const pending = data === undefined && !error

  return {
    games: data?.games ?? [],
    isLoading: isLoading || pending,
    isError: Boolean(error)
  }
}
